/**
 * Tranzit broker/shipper carrier directory API (Phase 1 — server-side reads).
 * Mirror: backend/src/config/tranzitCarrierDirectory.ts
 */

export const TRANZIT_API_PREFIX = '/api/tranzit' as const;

export const TRANZIT_API_CARRIER_DIRECTORY_LIST_PATH = '/carrier-directory/list' as const;
export const TRANZIT_API_CARRIER_DIRECTORY_AVAILABLE_NEAR_PATH =
  '/carrier-directory/available-near' as const;
export const TRANZIT_API_CARRIER_DIRECTORY_PROFILE_PATH = '/carrier-directory/profile' as const;

export const TRANZIT_CARRIER_DIRECTORY_MAX_RESULTS = 1000;

export const TRANZIT_CARRIER_DIRECTORY_MAX_SCAN = 5000;

export const TRANZIT_CARRIER_DIRECTORY_SCAN_BATCH = 500;

export const TRANZIT_CARRIER_DIRECTORY_ROW_KEYS = [
  'id',
  'companyName',
  'companyRep',
  'phoneNumber',
  'email',
  'state',
  'loadTypes',
  'trailerTypes',
  'endorsements',
  'mcNumber',
  'dotNumber',
  'userType',
  'role',
  'rating',
  'equipmentTypes',
  'status',
  'location',
  'currentLocation',
  'eldApiKey',
  'availableDate',
  'insurance',
  'hazmat',
  'phone',
  'companyId',
] as const;

export type TranzitCarrierDirectoryRowKey = (typeof TRANZIT_CARRIER_DIRECTORY_ROW_KEYS)[number];
